export default __webpack_public_path__ + "static/media/linkedin.18aac8a9.png";